import { memo } from 'react';
import { Calendar } from 'antd';
import type { CalendarProps } from 'antd';
import enUS from 'antd/es/calendar/locale/en_US';
import type { Dayjs } from 'dayjs';
import type { WorkOrderListItem } from '../../../../types/InfrastructureManagerTypes';
import { CALENDAR_DAY_KEY_FORMAT, CALENDAR_WEEKDAY_LABELS } from '../constants';
import { getCellSelectedId } from '../workOrderList.utils';
import CalendarDayCell from './CalendarDayCell';
import styles from './WorkOrderCalendar.module.scss';

// antd reads weekday headings from the locale, so the design's labels go in here.
const CALENDAR_LOCALE = { ...enUS, lang: { ...enUS.lang, shortWeekDays: CALENDAR_WEEKDAY_LABELS } };

// The shared CalendarHeader sits above both views.
const NO_HEADER = () => null;

interface MonthViewProps {
  anchor: Dayjs;
  todayKey: string;
  dayIndex: Map<string, WorkOrderListItem[]>;
  selectedId: number | null;
  onSelect: (id: number) => void;
  onExpand: (id: number) => void;
}

const MonthView = ({ anchor, todayKey, dayIndex, selectedId, onSelect, onExpand }: MonthViewProps) => {
  const renderCell: CalendarProps<Dayjs>['fullCellRender'] = (date) => {
    const key = date.format(CALENDAR_DAY_KEY_FORMAT);
    const isOutside = date.month() !== anchor.month();
    const orders = isOutside ? undefined : dayIndex.get(key);
    return (
      <CalendarDayCell
        day={date.date()}
        orders={orders}
        selectedId={getCellSelectedId(orders, selectedId)}
        isOutside={isOutside}
        isToday={key === todayKey}
        onSelect={onSelect}
        onExpand={onExpand}
      />
    );
  };

  return (
    <Calendar
      className={styles.monthView}
      value={anchor}
      mode="month"
      locale={CALENDAR_LOCALE}
      headerRender={NO_HEADER}
      fullCellRender={renderCell}
    />
  );
};

export default memo(MonthView);
